"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createListPinsResponse = void 0;

var _utils = require("../../../utils");

var createListPinsResponse = function createListPinsResponse(raw) {
  var model = (0, _utils.parseModel)(raw, {
    result: {
      path: 'GetPinDropsResult[0]',
      model: _utils.genericAsResultHeader
    },
    returnedCount: {
      path: 'PinDrops[0].PinDrop.length',
      type: Number
    },
    response: {
      path: 'PinDrops[0].PinDrop',
      model: {
        id: {
          type: Number,
          path: 'Region[0].pinDropId'
        },
        fullUrl: {
          type: String,
          path: 'fullURL'
        },
        imageId: {
          type: Number,
          path: 'Region[0].ImageId'
        },
        regionId: {
          type: Number,
          path: 'Region[0].Id'
        },
        layerId: {
          type: Number,
          path: 'Region[0].AnnotationId'
        },
        displayOrder: {
          type: Number,
          path: 'Region[0].DisplayOrder' // Other region props -- needed?
          // type: {type: Number, path: 'Region[0].Type'},
          // zoom: {type: Number, path: 'Region[0].Zoom'},
          // isSelected: {type: BooleanAsNumber, path: 'Region[0].Selected'},
          // negativeROA: {type: Number, path: 'Region[0].NegativeROA'},
          // canAnalyze: {type: BooleanAsNumber, path: 'Region[0].Analyze'},
          // displayId: {type: Number, path: 'Region[0].DisplayId'},
          // lineColor: {type: Number, path: 'Region[0].LineColor'},
          // globalId: {type: String, path: 'Region[0].GlobalId'},
          // numDimensions: {type: Number, path: 'Region[0].NumDimensions'}

        }
      }
    }
  }); // This API doesn't consistently return the returnCount; if there are no results then the response is just empty.
  // Make it consistent.

  if (!model.returnedCount) {
    model.returnedCount = 0;
    model.response = [];
  }

  return model;
};

exports.createListPinsResponse = createListPinsResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/annotations/response-parsers/list-pins-response.js
// module id = 237
// module chunks = 0